// dynamic loading of bootstrap for module federation
import('bootstrap');
